/**
 * App引导浮动按钮
 */
import './appGuide.css'
import { getPlatform } from '../../tools/getPlatform'
const isApp = userAgent => /(?:yixinliApp)/.test(userAgent)
const isIOS = userAgent => /(iPhone|iPad|iPod|iOS)/i.test(userAgent)
const isExit = () => document.getElementById('AppGuideElement') !== null

export const AppGuide = {
  /**
   * 初始化组件
   * @param options
   * @param callback
   */
  init(options, callback) {
    if (isApp(navigator.userAgent) || isExit()) {
      return
    }
    if (Object.prototype.toString.call(options) !== '[object Object]') {
      options = {}
    }

    let { text, bgColor,customClass } = options

    let $el = document.createElement('div')
    $el.id = 'AppGuide'
    $el.className = 'app-guide'
    if(customClass) $el.className += ` ${customClass}`
    let $button = document.createElement('button')
    $button.textContent = text || '下载壹心理App'
    $button.backgroundColor = bgColor || '#6982fa'

    if (callback && typeof callback === 'function') {
      $button.addEventListener('click', callback)
    }

    $el.append($button)
    document.body.append($el)
  },
  download(utmSource = '', isIosStore = true) {
    // 如果是IOS，直接调起Apple Store
    if (isIOS(navigator.userAgent) && isIosStore) {
      window.location.href =
        'https://itunes.apple.com/app/apple-store/id994051627?pt=1667142&ct=m5&mt=8'
    } else {
      window.location.href = `https://m.xinli001.com/download${
        utmSource ? '?utm_source=' + utmSource : ''
      }`
    }
  }
}



// WEBPACK FOOTER //
// ./src/frontend-lib/component/AppGuide/index.js